import Validators from '../../../forms/Validators'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Checkbox from '../../forms/Checkbox/Checkbox'
import koalition from '../../../api/koalition'
import { useCharacters } from '../../../contexts/Characters'
import { useToaster } from '../../../contexts/Toaster'
import { useRef } from 'react'
import { capitalize, mgeRating } from '../../../utilities/helpers'
import { unitTypes } from '../../../utilities/constants'
import Select from '../../forms/Select/Select'

const FixedMgeForm = ({ character }) => {
    const toaster = useToaster()
    const mgeValues = character.mge || {}
    const unitTypesOptions = unitTypes.map((unitType) => ({ value: unitType, label: capitalize(unitType) }))
    const mgeReasonOptions = [
        { value: 'check', label: 'Just curious to see something' },
        { value: 'unlock', label: 'Unlocking a new hero i have no medals of' },
        { value: 'half', label: 'Unlocking a new hero i need 5 more medals of' },
        { value: 'medals', label: 'Getting medals for a hero i already have' },
    ]

    const updateFixedMgeFormRef = useRef() 
    updateFixedMgeFormRef.current = () => {
        koalition.put(`/characters/${character._id}`, { mge: { ...(character.mge || {}), ...form.$state.value } }).then((response) => {
            toaster.success('Data saved successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ onSubmit: () => updateFixedMgeFormRef.current(), controls: {
        apply: { validators: [Validators.required], value: mgeValues.apply },
        targetUnitType: { validators: [Validators.required], value: mgeValues.targetUnitType },
        reason: { validators: [Validators.required], value: mgeValues.reason },
    } })

    return (
        <div className="row">
            {form?.$state && (
                <form className="container-fluid" onSubmit={form.$state.onSubmit}>
                    <main className="row">
                        <div className="col-12 mb-3">
                            <Checkbox label="Apply for fixed MGE" control={form.$state.controls.apply} />
                        </div>

                        <div className="col-12">
                            <div className={`card ${form.$state.controls.apply.value ? '' : 'disabled'}`}>
                                <div className="col-12 mb-3">
                                    <Select options={unitTypesOptions} control={form.$state.controls.targetUnitType} label="Desired hero unit type" />
                                </div>

                                <div className="col-12 mb-3">
                                    <Select options={mgeReasonOptions} control={form.$state.controls.reason} label="Reason for applying" />
                                </div>
                            </div>
                        </div>
                    </main>

                    <footer className="row justify-content-between align-items-center mt-4">
                        <div className="col-auto ml-auto">
                            <button type="submit" className="primary large" disabled={form.$state.invalid}>Save</button>
                        </div>
                    </footer>
                </form>
            )}
        </div>
    )
}

export default FixedMgeForm